import { __awaiter } from "tslib";
import React from 'react';
import { createContainer } from 'unstated-next';
// @ts-ignore
import ClockSkew from 'clockskew/client';
import gql from 'graphql-tag';
import { useApolloClient } from '@apollo/react-hooks';
const heartbeatQuery = gql `
  query heartbeat($key: String!) {
    heartbeat(key: $key) {
      serverTime
    }
  }
`;
const useOverlayHeartbeat = (key) => {
    const [skew, setSkew] = React.useState(0);
    const client = useApolloClient();
    React.useEffect(() => {
        if (!key) {
            return;
        }
        const serverClient = new ClockSkew({
            timeout: 10000,
            interval: 1000,
            history: 10,
            tolerance: 100,
            waitInteval: 30000,
            minSkewValues: 5,
            minRttValues: 5,
            getServerTime: (getTime, callback) => __awaiter(void 0, void 0, void 0, function* () {
                var _a;
                const start = getTime();
                const result = yield client.query({
                    query: heartbeatQuery,
                    fetchPolicy: 'network-only',
                    variables: { key }
                });
                const end = getTime();
                callback(null, [start, new Date((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.heartbeat.serverTime).getTime(), end]);
            }),
            onSkew(skew) {
                setSkew(skew);
            }
        });
        serverClient.start();
        return () => {
            serverClient.stop();
        };
    }, [key]);
    return {
        skewMs: skew
    };
};
export const OverlayHeartbeat = createContainer(useOverlayHeartbeat);
//# sourceMappingURL=useOverlayHeartbeat.js.map